import React from 'react';
import IconWrapper from '../../../IconWrapper';
const SearchIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M10.874 11.582a6 6 0 1 1 .707-.707l3.273 3.271a.5.5 0 0 1-.708.708l-3.272-3.272ZM12 7A5 5 0 1 1 2 7a5 5 0 0 1 10 0Z" })));
export default SearchIconSmall;
//# sourceMappingURL=SearchIconSmall.js.map